import { default as Icon } from './Icon';

export * from './Icon.data';
export default Icon;
